import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { Col, Container, Row, Button } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';
import AlertModal from '../../../../shared/components/Modal';
import ModalInvestingTeam from './ModalInvestingTeam';
import ModalDocumentMembership from './ModalDocumentMembership';

const ListInvestingTeamActions = ({ data, feasibility, listarEquipoInvestigacion, membersTeam }) => {
    const [openModal, setOpenModal] = React.useState(false);
    const [openModalDocuments, setOpenModalDocuments] = React.useState(false);
    const [showDeleteModal, setDeleteModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);

    useEffect(() => {
        console.log(data.data.original);
    }, []);

    const deleteMember = async () => {
        let dataSend =
        {
            id_equipo_inv: data.data.original.id_equipo_inv
        }
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}equipoinves/delete`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => response.json()).then(data => {
            listarEquipoInvestigacion();
        }).catch(err => {
            setErrorModal(true);
        });
    }

    const openUpdateModal = () => {
        setOpenModal(true);
    }

    const openDocumentModal = () => {
        setOpenModalDocuments(true);
    }

    return (<Fragment>
        <td role="cell">

            {/*
            <Tooltip title="Documentacion del Miembro">
                <IconButton style={{ fontSize: '15px' }} onClick={() => openDocumentModal()}>
                    <FontAwesomeIcon icon={faFileAlt} />
                </IconButton>
            </Tooltip>*/}

            <Tooltip title="Gestionar Miembro">
                <IconButton style={{ fontSize: '15px' }} onClick={() => openUpdateModal()}>
                    <FontAwesomeIcon icon={faEdit} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Eliminar Miembro">
                <IconButton style={{ fontSize: '15px' }} onClick={() => setDeleteModal(true)}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                </IconButton>
            </Tooltip>
        </td>

        <ModalInvestingTeam
            openModal={openModal}
            closeModal={() => setOpenModal(false)}
            feasibility={feasibility}
            listarEquipoInvestigacion={() => listarEquipoInvestigacion()}
            data_profesional={data.data.original}
            membersTeam={membersTeam}
        />

        <ModalDocumentMembership
            openModal={openModalDocuments}
            closeModal={() => setOpenModalDocuments(false)}
            idUser={data.data.original.id_usuario}
            idTeamInvestorMember={data.data.original.id_equipo_inv}
        />

        <AlertModal
            color="warning"
            title="Esta seguro de eliminar este miembro del Equipo Investigador?"
            modal={showDeleteModal}
            onOk={() => deleteMember()}
            toggle={() => setDeleteModal(false)}
        />

        <AlertModal
            color="success"
            title="Miembro del Equipo Investigador eliminado correctamente"
            modal={successModal}
            onOk={() => {
                setSuccessModal(false);
                setOpenModal(false);
            }}
            toggle={() => setSuccessModal(false)}
        />

        <AlertModal
            color="danger"
            title="Ha ocurrido un error al eliminar el Miembro del Eequipo Investigador"
            modal={errorModal}
            onOk={() => setErrorModal(false)}
            toggle={() => setErrorModal(false)}
        />
    </Fragment>)
}

export default ListInvestingTeamActions;